import React from 'react';
import { Button } from 'react-bootstrap';
import { FieldArray } from 'formik';
import { InputText } from '../../../../formikBindings';
import QuestionList from '../questions';
import { ISectionListProps } from './types';
import SectionFactory from '../SectionFactory';
import { FormGroup } from '../../../../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SectionList.module.css';

const SectionList: React.FC<ISectionListProps> = ({ sections }) => (
  <FieldArray
    name="sections"
    validateOnChange={false}
    render={(arrayHelpers) => (
      <>
        {sections.map((section, sectionIndex) => (
          <div className={styles.section} key={section.id}>
            <span className={styles.sectionText}>
              Section {sectionIndex + 1} -{' '}
            </span>
            <span>{section.heading ? section.heading : '[Untitled]'}</span>

            <div className={styles.buttonContainer}>
              <Button
                variant="info"
                size="sm"
                type="button"
                onClick={() => {
                  arrayHelpers.insert(
                    sectionIndex + 1,
                    SectionFactory.Create(),
                  );
                }}
              >
                <FontAwesomeIcon icon="plus" />
              </Button>
              {sections.length > 1 && (
                <Button
                  variant="danger"
                  size="sm"
                  type="button"
                  className="ml-1"
                  onClick={() => {
                    arrayHelpers.remove(sectionIndex);
                  }}
                >
                  <FontAwesomeIcon icon="times" />
                </Button>
              )}
            </div>

            <div className={styles.body}>
              <FormGroup
                label="Heading"
                name={`sections.${sectionIndex}.heading`}
                required
              >
                <InputText
                  name={`sections.${sectionIndex}.heading`}
                  maxLength={100}
                />
              </FormGroup>

              <QuestionList
                sectionIndex={sectionIndex}
                questions={section.questions}
              />
            </div>
          </div>
        ))}
      </>
    )}
  />
);

export default SectionList;
